<template>
    <div class="course-direction-detail" :class="{'mobile-course-direction-detail':isMobile}">
        <div class="big-box">
            <div class="box">
                <header :title="learningDirection.directionTitle">{{learningDirection.directionTitle}}</header>
                <div>
                    <p>{{learningDirection.directionDesc}}
                    </p>
                </div>
            </div>

            <div class="swiper-container">
                <!--                轮播图-->
                <swiper :options="swiperOption" ref="mySwiper">
                    <!-- slides -->
                    <swiper-slide v-for="(item,key) in subjectList" :key="key">
                        <div class="course-type">
                            <header>{{item.thematicTitle}}</header>
                            <footer>
                                <ul>
                                    <li :title="courseList.courseTitle" v-for="(courseList,key) in item.courseList"
                                        :key="key" @click="toCourse(courseList.courseId)">{{courseList.courseTitle}}
                                    </li>
                                </ul>
                            </footer>
                        </div>
                    </swiper-slide>
                    <!--分页器-->
                    <!--                    <div class="swiper-pagination" slot="pagination"></div>-->
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                    <!--<div class="swiper-scrollbar" slot="scrollbar"></div>-->
                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
    import {showError} from "@utils/msg";
    import {learningDirectionDetail} from "@api/courseDirection-api"
    import common from "../../mixin/common";

    export default {
        name: "coueseDirectionDetail",
        mixins: [common],
        data() {
            return {
                learningDirection: {},
                subjectList: [1, 2, 3, 4, 5],
                directionId: '',

                //swiper轮播图
                swiperOption: { //更多的参数的配置看swiper4官网介绍：http://www.swiper.com.cn/api/navigation/210.html
                    slidesPerView: 3,
                    notNextTick: true,

                    observer: true,//修改swiper自己或子元素时，自动初始化swiper
                    observeParents: true,//修改swiper的父元素时，自动初始化swiper
                    direction: 'horizontal',
                    grabCursor: true,
                    setWrapperSize: true,
                    autoHeight: true,
                    // pagination : '.swiper-pagination',
                    // paginationClickable :true,
                    navigation: { //最新版本的需要这样配置，按钮才有效
                        prevEl: '.swiper-button-prev',//上一张
                        nextEl: '.swiper-button-next'//下一张
                    },
                    scrollbar: '.swiper-scrollbar',//滚动条
                    mousewheelControl: true,
                    clickable: true,

                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                        // type: "bullets"
                    },
                },
            }
        },
        created() {
            // 判断当前设备
            if (this.isMobile && window.innerWidth > 992) {
                this.swiperOption.slidesPerView = 3;
            } else if (this.isMobile && window.innerWidth > 576) {
                this.swiperOption.slidesPerView = 2;
            } else if (this.isMobile) {
                this.swiperOption.slidesPerView = 1;
            }

            this.directionId = this.$route.query.directionId
            learningDirectionDetail(this.directionId).then((res) => {
                if (res.code === 0) {
                    if (res.canStudyDirection) {
                        this.learningDirection = res.learningDirection
                        this.subjectList = res.learningDirection.thematicList
                    } else {
                        //    防止没买手动改url
                        this.$router.push({
                            path: "/other/course-direction",
                            query: {
                                directionId: this.directionId
                            }
                        })
                    }
                } else {
                    showError("获取学习方向出错", res.msg)
                }
            })
        },
        methods: {
            toCourse(courseId) {
                const {href} = this.$router.resolve({
                    name: 'courseDetail',
                    params: {
                        courseId: courseId
                    }
                });
                window.open(href, '_blank')


            }
        }

    }
</script>

<style scoped lang="less">
    .course-direction-detail {
        border-top: 1px solid #ffffff;
        background: #F6F6F6;
    }

    .swiper-container {
        margin: 0 50px;
    }

    .big-box {
        width: 1300px;
        margin: auto;

        header {
            font-size: 46px;
            padding: 50px 0 20px 0;
        }

        p {
            color: #999999;
            font-size: 12px;
            margin-bottom: 50px;
        }

        .course-type {
            padding: 0 50px;
            width: 100%;
            max-width: 350px;
            margin: 0 auto;

            header {
                height: 60px;
                line-height: 60px;
                text-align: center;
                padding: 0 20px;
                background: #00CF8C;
                color: white;
                font-size: 18px;
                border-radius: 4px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            footer {
                background: white;
                padding: 10px;

                margin-bottom: 100px;

                ul {
                    width: 100%;
                    height: 360px;
                    overflow: auto;
                }

                li {
                    /*display: inline-block;*/
                    text-align: center;
                    width: 80%;
                    margin: 10px auto;
                    padding: 10px;
                    background: #F4F4F4;
                    color: black;
                    border-radius: 20px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                li:hover {
                    cursor: pointer;
                    color: white;
                    background: #00CF8C;
                }
            }
        }

    }

    /*滚动条样式*/
    .chapter::-webkit-scrollbar { /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
        width: 10px;
        height: 10px;
    }

    /*控制整个滚动条*/
    ::-webkit-scrollbar {
        background-color: lightgray;
        /*background-color: black;*/
        width: 6px;
        height: 6px;
        background-clip: padding-box;
        display: none;
    }

    /*滚动条两端方向按钮*/
    ::-webkit-scrollbar-button {
        /*background-color: pink;*/
        display: none;
    }

    /*滚动条中间滑动部分*/
    ::-webkit-scrollbar-thumb {
        background-color: #888888;
        border-radius: 4px;
    }

    /*滚动条右下角区域*/
    ::-webkit-scrollbar-corner {
        /*background-color: red;*/
        display: none;
    }

    // 移动端样式
    .mobile-course-direction-detail {


        .big-box {
            background: white;
            width: 100%;
            padding: 0 10px;
            margin-top: 8px;

            header {
                font-size: 16px;
                padding: 5px 0;
            }

            p {
                font-size: 12px;
                margin-bottom: 40px;
            }

            .swiper-container {
                margin: 0;
            }

            .course-type {
                padding: 0 40px;

                header {
                    padding: 0 20px;
                    font-size: 18px;
                }
            }
        }

        .box {
            width: 100%;
        }
    }

</style>
